import { ShareLinkOtherSettings } from "slot-definitions"
import { RegimeLandingTopPanel } from "routes/facilities/facilities-slot-definitions"
import { isEnabled } from "lib/@components/feature"
import { RequestedFieldsEditor } from "./requested-fields-editor"
import { ShareLinkIntroductionLandingPanel } from "./share-link-introduction-landing-panel"
import { FEATURE_FLAG_SHARE_LINK_FIELDS } from "./feature-flag-share-link-fields"

// Per-type field-type plugins live in `field-types/<type>.runtime.js`. Each one self-registers its
// metadata in the `RegisterRequestedFieldType` registry AND plugs its `RequestedFieldInput` /
// `RequestedFieldValue` (and, for choice/currency, `RequestedFieldEditor`) renderers. They are
// auto-discovered by the `.runtime.js` module scan, so adding a new field type is a drop-in single
// file with zero edits here or on the server.

ShareLinkOtherSettings.plug(
    <RequestedFieldsEditor $lazy priority={40} if={() => isEnabled(FEATURE_FLAG_SHARE_LINK_FIELDS)} />
)

// The recipient introduction renders as a landing panel above the facilities grid on the share landing
// (it self-gates on the link's saved settings). Requested information is intentionally NOT a landing
// panel: it lives only in the "Requested Information" regime tab (RequestedInformationTabRegistrar,
// plugged into REGIME_ASSETS_TAB), so it no longer duplicates that tab on regimes that render the tab
// bar. Tradeoff: recipient regimes that do not render the regime tab bar (no isInRegime /
// advanced-regime-tabs) therefore show no requested-information form.
RegimeLandingTopPanel.plug(<ShareLinkIntroductionLandingPanel $lazy priority={10} />)
